
import React, { memo } from 'react';
import { ScaleProvider } from '../../context/ScaleContext';

import './Editor.css';

const Editor = ({ children }) => {
  return (
    <div className="editor">
      <ScaleProvider>
        {children}
      </ScaleProvider>
    </div>
  );
};

export default memo(Editor);
